/**
 * Знак валюты («₽») в тексте оборачивается в span.currency-sign — как в
 * QuestPageHelper#format_price: у Stolzl нет этого глифа, без своего шрифта
 * браузер подставлял его из шрифта с засечками.
 */
export const CURRENCY_SIGN_CLASS = 'currency-sign'

/**
 * Записать текст в элемент, выделив каждый знак валюты отдельным span.
 * @param {HTMLElement} element - куда выводить
 * @param {string} text - текст с суммами, например «Списано 3000 ₽»
 * @param {string} sign - знак валюты, который нужно выделить
 */
export function renderWithCurrency(
  element: HTMLElement,
  text: string,
  sign: string = '₽'
): void {
  const parts = text.split(sign)
  const nodes: Node[] = []

  parts.forEach((part, index) => {
    if (part) nodes.push(document.createTextNode(part))
    if (index < parts.length - 1) {
      const span = document.createElement('span')
      span.className = CURRENCY_SIGN_CLASS
      span.textContent = sign
      nodes.push(span)
    }
  })

  element.replaceChildren(...nodes)
}

/**
 * HTML-разметка знака валюты для шаблонных строк (innerHTML).
 * @param {string} sign - знак валюты
 * @return {string} span.currency-sign со знаком
 */
export function currencySignHtml(sign: string = '₽'): string {
  return `<span class="${CURRENCY_SIGN_CLASS}">${sign}</span>`
}
